import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import { AppBar, styled, useTheme } from "@mui/material";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import SupplierLogo from "components/SupplierLogo";
import { IconButtonAnimate } from "components/animate";
import { HEADER, NAVBAR } from "config";
import useOffSetTop from "hooks/useOffSetTop";
import useResponsive from "hooks/useResponsive";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import cssStyles from "utils/cssStyles";
import { LanguagePopover } from "pages/customTemplates/DefaultSupplierV2/components/LanguagePopover";
type RootStyleProps = {
  isCollapse: boolean;
  isOffset: boolean;
  verticalLayout: boolean;
};

const RootStyle = styled(AppBar, {
  shouldForwardProp: (prop) =>
    prop !== "isCollapse" && prop !== "isOffset" && prop !== "verticalLayout",
})<RootStyleProps>(({ isCollapse, isOffset, verticalLayout, theme }) => ({
  ...cssStyles(theme).bgBlur(),
  boxShadow: "none",
  height: HEADER.MOBILE_HEIGHT,
  zIndex: theme.zIndex.appBar + 1,
  transition: theme.transitions.create(["width", "height"], {
    duration: theme.transitions.duration.shorter,
  }),
  [theme.breakpoints.up("lg")]: {
    height: HEADER.DASHBOARD_DESKTOP_HEIGHT,
    width: `calc(100% - ${NAVBAR.DASHBOARD_WIDTH + 1}px)`,
    paddingBottom: "4px",
    paddingTop: "4px",
    borderBottom: `1px solid ${theme.palette.text.borderLine}`,
    ...(isCollapse && {
      width: `calc(100% - ${NAVBAR.DASHBOARD_COLLAPSE_WIDTH}px)`,
    }),
    ...(isOffset && {
      height: HEADER.DASHBOARD_DESKTOP_OFFSET_HEIGHT,
    }),
    ...(verticalLayout && {
      width: "100%",
      height: HEADER.DASHBOARD_DESKTOP_OFFSET_HEIGHT,
      backgroundColor: theme.palette.background.default,
    }),
  },
}));

export default function SupplierHeader({
  onOpenSidebar,
  isCollapse = false,
  verticalLayout = false,
}) {
  const supplier_ = useSelector((state: any) => state.supplier);
  const supplier = supplier_?.supplier;
  const { customTheme } = supplier || "";
  const { t } = useTranslation();
  const theme = useTheme();

  const isOffset =
    useOffSetTop(HEADER.DASHBOARD_DESKTOP_HEIGHT) && !verticalLayout;

  const isDesktop = useResponsive("up", "lg");

  return (
    <RootStyle
      isCollapse={isCollapse}
      isOffset={isOffset}
      verticalLayout={verticalLayout}
    >
      <Toolbar
        sx={{
          minHeight: "100% !important",
          px: { lg: 5 },
          justifyContent: isDesktop ? "flex-end" : "space-between",
        }}
      >
        {
          isDesktop && verticalLayout && <SupplierLogo sx={{ mr: 2.5 }} />
          // <Logo sx={{ mr: 2.5 }} />
        }

        {!isDesktop && (
          <IconButtonAnimate
            onClick={onOpenSidebar}
            sx={{ mr: 1, color: "text.primary" }}
          >
            <MenuOpenIcon />
          </IconButtonAnimate>
        )}

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          <LanguagePopover />
        </Box>
      </Toolbar>
    </RootStyle>
  );
}
